import { render, staticRenderFns } from "./ChatSheet.vue?vue&type=template&id=502ef2d3&scoped=true"
import script from "./ChatSheet.vue?vue&type=script&lang=js"
export * from "./ChatSheet.vue?vue&type=script&lang=js"
import style0 from "./ChatSheet.vue?vue&type=style&index=0&id=502ef2d3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ef2d3",
  null
  
)

export default component.exports